import resourceCard, { resourceCardVariants, type ResourceCardVariantsType } from './resource-card';
import type { Utility } from '../../../types/utility';

const cards = {
  resourceCard,
};

export const cardsVariants = {
  resourceCard: resourceCardVariants,
};

export type CardsComponentsType = 'resourceCard';

type CombinedCardVariantsType = ResourceCardVariantsType;

export interface CardsType {
  /** The Card subcomponent types. */
  SubComponents: Record<CardsComponentsType, Utility.VariantKeyModes<CombinedCardVariantsType>>;
  /** The Resource Card component types */
  ResourceCard: Utility.VariantKeys<ResourceCardVariantsType>;
}

export default cards;
